<template>
  <div class="help" ref="help">
    <div class="centent-mobile">
      <Header></Header>
      <div class="title">{{ $t("helpFeedbackPage.help") }}</div>
      <div v-if="boxShow">
        <h1 class="faqh">{{ $t("helpFeedbackPage.title1") }}</h1>
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item :title="$t('helpFeedbackPage.question1')" name="1">
            {{ $t("helpFeedbackPage.answer1") }}
          </van-collapse-item>
        </van-collapse>

        <h1 class="faqh">{{ $t("helpFeedbackPage.title2") }}</h1>
        <van-collapse v-model="questionList" accordion>
          <van-collapse-item :title="$t('helpFeedbackPage.question2')" name="2">
            {{ $t("helpFeedbackPage.answer2") }}
          </van-collapse-item>
          <van-collapse-item :title="$t('helpFeedbackPage.question3')" name="3">
            {{ $t("helpFeedbackPage.answer3") }}
          </van-collapse-item>
          <van-collapse-item :title="$t('helpFeedbackPage.question4')" name="4">
            {{ $t("helpFeedbackPage.answer4") }}
          </van-collapse-item>
        </van-collapse>

        <h1 class="faqh">{{ $t("helpFeedbackPage.title3") }}</h1>
        <van-collapse v-model="questionList" accordion>
          <van-collapse-item :title="$t('helpFeedbackPage.question5')" name="5">
            {{ $t("helpFeedbackPage.answer5") }}
          </van-collapse-item>
          <van-collapse-item :title="$t('helpFeedbackPage.question6')" name="6">
            {{ $t("helpFeedbackPage.answer6") }}
          </van-collapse-item>
          <van-collapse-item :title="$t('helpFeedbackPage.question7')" name="7">
            {{ $t("helpFeedbackPage.answer7") }}
          </van-collapse-item>
        </van-collapse>

        <h1 class="faqh">{{ $t("helpFeedbackPage.title4") }}</h1>
        <van-collapse v-model="questionList" accordion>
          <van-collapse-item :title="$t('helpFeedbackPage.question8')" name="8">
            {{ $t("helpFeedbackPage.answer8") }}
          </van-collapse-item>
          <van-collapse-item :title="$t('helpFeedbackPage.question9')" name="9">
            {{ $t("helpFeedbackPage.answer9") }}
          </van-collapse-item>
        </van-collapse>

        <button class="box1-faq button" @click="boxShow = true">
          {{ $t("helpFeedbackPage.FAQ") }}
        </button>
        <button class="box1-contact button" @click="boxShow = false">
          {{ $t("helpFeedbackPage.contact") }}
        </button>
      </div>

      <div v-if="!boxShow">
        <div class="box-card">
          <p class="p-title" v-html="notFound"></p>
          <p>{{ $t("helpFeedbackPage.memo") }}</p>
          <ul>
            <li>{{ $t("helpFeedbackPage.surveyNumber") }}</li>
            <li>{{ $t("helpFeedbackPage.surveyTitle") }}</li>
            <li>{{ $t("helpFeedbackPage.surveyReward") }}</li>
            <li>{{ $t("helpFeedbackPage.joinDate") }}</li>
          </ul>
          <div class="formLine">
            <div>{{ $t("helpFeedbackPage.name") }}</div>
            <input type="text" v-model="submintFrom.name" />
          </div>
          <div class="formLine">
            <div>{{ $t("helpFeedbackPage.email") }}</div>
            <input type="text" v-model="submintFrom.email" />
          </div>
          <div class="formLine">
            <div>{{ $t("helpFeedbackPage.content") }}</div>
            <textarea v-model="submintFrom.content"></textarea>
          </div>
          <div class="formLine">
            <div>{{ $t("helpFeedbackPage.vc") }}</div>
            <div class="verificationCode">
              <!--<s-identify :identifyCode="identifyCode"></s-identify>-->
              <img
                class="vcode"
                :src="vcodeSrc"
                @click="refreshCodeImage"
                :alt="$t('helpFeedbackPage.changeCodeImage')"
                :title="$t('helpFeedbackPage.changeCodeImage')"
              />
            </div>
            <input type="text" v-model="submintFrom.code" />
          </div>
          <div class="submit" @click="onsubmit">
            {{ $t("helpFeedbackPage.submit") }}
          </div>

          <button class="FAQ button" @click="boxShow = true">
            {{ $t("helpFeedbackPage.FAQ") }}
          </button>
          <button class="FAQ button box2-contact" @click="boxShow = false">
            {{ $t("helpFeedbackPage.contact") }}
          </button>
        </div>
      </div>
      <van-popup
        class="popup"
        v-model="showSheet"
        position="right"
        :style="{ height: '100%', width: '50vw' }"
      >
        <van-cell
          icon="guide-o"
          :title="$t('sideBar.lang')"
          @click="handleJump(1)"
        />
        <van-cell
          icon="gold-coin-o"
          :title="$t('sideBar.jifen')"
          @click="handleJump(2)"
        />
        <van-cell
          icon="question-o"
          :title="$t('sideBar.about')"
          @click="handleJump(3)"
        />
        <van-cell
          icon="service-o"
          :title="$t('sideBar.help')"
          @click="handleJump(4)"
        />
      </van-popup>
      <van-action-sheet
        class="sheet"
        v-model="showLangSheet"
        :actions="actions"
        @select="onSelect"
      />
      <!-- 页脚 -->
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import SIdentify from "./identify/identify.vue";
import Footer from "../../components/mycom/footer.vue";
import Header from "../../components/mycom/header.vue";

import { Notify, Collapse, CollapseItem, Toast } from "vant";
import { Feedback } from "@/api/api.js";

export default {
  components: { SIdentify, Footer, Header },
  data() {
    return {
      questionList: [
        "关于WEOPINIONS的问题",
        "有关调查的问题",
        "有关隐私的问题",
        "关于徽章的问题",
        "关于美国红十字会的问题",
      ],
      activeNames: "",
      boxShow: true,
      emailShow: false,
      verificationCodeShow: false,
      // 图片验证码
      identifyCode: "1234",
      // 验证码规则
      email: "",
      verificationCode: "",
      showSheet: false,
      showLangSheet: false,
      actions: [
        /*{ id: "1", name: "中文" },*/
        { id: "2", name: "English" },
      ],
      submintFrom: {
        name: "",
        email: "",
        code: "",
        content: "",
      },
      vcodeSrc: "http://www.weopinions.com/api/v1/SecurityCode",
    };
  },
  methods: {
    toHome() {
      this.$router.push({
        path: `/`,
      });
    },
    gourl() {
      this.$router.push({
        path: `register`,
      });
    },
    goto() {
      this.$router.push({
        path: `offenQuestion`,
      });
    },
    refreshCodeImage() {
      let random = new Date().getTime();
      this.vcodeSrc = `http://www.weopinions.com/api/v1/SecurityCode?${random}`;
      //console.log(this.vcodeSrc)
    },
    openSheet() {
      //console.log(123);
      this.showSheet = !this.showSheet;
    },
    onSelect(value) {
      if (value.id == "1") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
      localStorage.setItem("lang", this.$i18n.locale);
      this.showSheet = false;
      this.showLangSheet = false;
    },

    handleJump(flag) {
      switch (flag) {
        case 1:
          this.showLangSheet = true;
          break;
        case 2:
          this.$router.push("/integralAward");
          break;
        case 3:
          this.$router.push("/aboutQuestionnaire");
          break;
        case 4:
          this.$router.push("/helpFeedback");
          // this.$router.push("/offenQuestion");
          break;
        default:
          break;
      }
    },
    refreshCode() {
      this.identifyCode = "dfsf";
    },
    changeCode() {
      //console.log(this.identifyCode);
      this.identifyCode = "dfsf";
      //console.log(this.identifyCode);
    },
    changeCode() {
      let codeText = "";
      let codeList = []; //验证码集合；
      let NandEList = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ];
      // 根据条件生成验证码集合；
      let leng = 4;
      for (let z = 0; z < leng; z++) {
        codeList[z] = NandEList[parseInt(Math.random() * NandEList.length)];

        // 为英文随机改变大写
        let uplow = Math.round(Math.random());
        if (uplow) {
          codeList[z] = codeList[z].toLocaleUpperCase();
          codeText += codeList[z];
        } else {
          codeText += codeList[z];
        }
        //渲染验证码
      }
      this.identifyCode = codeText;
    },
    onsubmit() {
      console.log(
        this.verificationCode,
        this.identifyCode,
        this.identifyCode === this.verificationCode
      );

      Feedback(this.submintFrom).then((res) => {
        //console.log(res)
        if (res.code === 200) {
          this.submintFrom.name = "";
          this.submintFrom.email = "";
          this.submintFrom.content = "";
          this.submintFrom.code = "";
          this.refreshCodeImage();

          Notify({ type: "primary", message: res.errors[0] });
        } else {
          Notify({ type: "warning", message: res.errors[0] });
        }
      });
    },
  },
  mounted() {
    this.changeCode();
    this.activeNames = this.$route.query.activeNames;
    this.boxShow = this.$route.query.type === "contact" ? false : true;
    if (localStorage.getItem("questionnaireItem") == 0) {
      //console.log(12333333333333);
      localStorage.setItem("questionnaireItem", 1);
      //this.$router.go(0);
      this.$refs.help.scrollTop = 0;
    }
  },
  computed: {
    newQuestionList: function () {
      return [
        this.$t("helpFeedbackPage.q1"),
        this.$t("helpFeedbackPage.q2"),
        this.$t("helpFeedbackPage.q3"),
        this.$t("helpFeedbackPage.q4"),
      ];
    },
    notFound: function () {
      return this.$t("helpFeedbackPage.notFound")
        .replace("{0}", '<span style="color: #ff9344">')
        .replace("{1}", "</span>");
    },
  },

  created() {
    // 判断是否是全屏显示
    console.log(1111, localStorage.getItem("questionnaireItem"));
    setTimeout(() => {
      if (
        localStorage.getItem("questionnaireItem") == 0 ||
        !localStorage.getItem("questionnaireItem")
      ) {
        localStorage.setItem("questionnaireItem", 1);
        //this.$router.go(0);
      }
    }, 100);
    //修改title
    document.title =
      "Help | FAQs | Customer Support | Weopinions description: Get help, more information or see our FAQs on our free surveys, membership or rewards. Find customer support for Weopinions members.";
  },
  beforeDestroy() {
    localStorage.setItem("questionnaireItem", 0);
  },
};
</script>
<style scoped>
.help {
  height: 100vh;
  overflow: auto;
}

.centent-mobile {
  width: 100%;
  min-height: calc(100vh - 98px);
  padding-top: 98px;
  margin: 0 auto;
  background-color: #f8f8f7;
}

header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 99;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}

.box-add {
  width: 85px;
  height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 60px;
  background-color: #2e67ea;
  text-align: center;
}

.pinios {
  width: calc(100% - 95px);
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.pinios > img {
  width: 192px;
  height: 48px;
  cursor: pointer;
}

.develop {
  width: 35px;
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
}

.develop > img {
  width: 35px;
  height: 35px;
  margin-right: 12px;
}

.title {
  /* margin-top: 98px; */
  margin-left: 16px;
  font-size: 24px;
  font-weight: bold;
}

.faqh {
  font-size: 16px;
  margin: 16px;
  font-weight: bold;
}

.box-card {
  width: calc(100% - 30px);
  /*min-height: 324px;*/
  margin-left: 15px;
  margin-top: 38px;
  background: #fefefe;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  border: 1px solid #e3dfdf;
  margin-bottom: 27px;
}

.box-card-item {
  width: calc(100% - 17px);
  margin-left: 9px;
  font-size: 16px;
  height: 65px;
  line-height: 65px;
  font-weight: bold;
  border-bottom: 1px solid #dddcdd;
}

.boder-none {
  border: none;
}

.button {
  padding: 0;
  margin: 0;
  border: none;
  width: calc(100% - 30px);
  height: 50px;
  background: #3d66e2;
  opacity: 1;
  border: 1px solid #3d66e2;
  margin-left: 15px;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
}

.box1-faq {
  margin-top: 16px;
}

.box1-contact {
  color: #000;
  border: 1px solid #e3dfdf;
  background: #fefefe;
  margin-top: 16px;
  margin-bottom: 32px;
}

/* box2 */
p {
  width: calc(100% - 18px);
  margin-left: 9px;
  font-size: 12px;
  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.p-title {
  margin-top: 20px;
  margin-bottom: 15px;
}

li {
  font-size: 12px;
  color: #000;
  margin-left: 24px;
  margin-top: 5px;
}

.formLine {
  width: calc(100% - 54px);
  margin-left: 40px;
  margin-top: 18px;
}

.formLine > div {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 8px;
}

.formLine > span {
  display: block;
  font-size: 10px;
  color: rgb(226, 20, 20);
  margin-top: 8px;
}

select {
  width: 100%;
  height: 28px;
  font-size: 12px;
  color: #323132;
  padding-left: 8px;
  border: none;
  background: #f2f3f2;
  border: 1px solid #dddcdd;
}

input {
  width: calc(100% - 8px);
  height: 28px;
  font-size: 12px;
  color: #323132;
  padding-left: 8px;
  border: none;
  background: #f2f3f2;
  border: 1px solid #dddcdd;
}

textarea {
  width: 100%;
  height: 28px;
  font-size: 12px;
  height: 95px;
  color: #323132;
  border: none;
  background: #f2f3f2;
  border: 1px solid #dddcdd;
  text-indent: 8px;
  padding-top: 8px;
}

.verificationCode {
  margin-left: 0;
}

.verificationCode > div {
  margin-bottom: 23px;
}

.submit {
  /* width: calc(100% - 265PX); */
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background-color: #4665da;
  color: #fff;
  font-weight: bold;
  font-size: 14px;
  border-radius: 5px 0;
  margin-left: 40px;
  margin-top: 37px;
  cursor: pointer;
}

.FAQ {
  width: calc(100% - 18px);
  margin-left: 9px;
  color: #000;
  background-color: #fff;
  border: 1px solid #dddcdd;
  margin-top: 23px;
}

.box2-contact {
  background: #4665da;
  border-radius: 0px 0px 0px 0px;
  color: #fff;
  margin-top: 16px;
  margin-bottom: 32px;
}

.vcode {
  height: 40px;
  width: 120px;
  cursor: pointer;
}
</style>
<style scoped>
@media only screen and (min-width: 768px) {
  .popup {
    position: fixed;
    width: 50%;
    max-width: 384px;
    right: calc(50% - 384px);
  }
  .centent-mobile /deep/ .van-overlay {
    width: 100%;
    max-width: 768px;
    left: 50%;
    transform: translateX(-50%);
  }
  .centent-mobile /deep/ .sheet {
    width: 100%;
    max-width: 768px;
    margin-left: calc(50% - 384px);
    /* left: 50%; */
    /* transform: translateX(-50%); */
  }
}
button {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/helpFeedback/HelpFeedback.vue